import 'angular:locale/data:fr';(globalThis.$localize ??= {}).locale = "fr";
